export default __webpack_public_path__ + "017abf4c7048ab0ffb4f1987614b978b.png";